import type { GTMEventName } from "@jti/fe-message-bus";

import type { StoreLocatorCommonApi, StoreLocatorProviderProps } from "../useStoreLocator";

export type UseYandexMapsStoreLocator = (props: StoreLocatorProviderProps) => StoreLocatorCommonApi;

export const StoreLocatorEvents = {
  SearchClick: "store_locator_search" as const,
} satisfies Record<string, GTMEventName>;
